module.exports = __webpack_public_path__ + "img/apropos_zeichen_4f.a9c9fb47.svg";